import { Injectable, inject } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {tap} from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})
export class SnackBarService {
  private snackBar = inject(MatSnackBar);
  private translate = inject(TranslateService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  i18nMessage(i18nCode:string, params: object = {}, config: MatSnackBarConfig = {duration: 3000}) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.snackBar.open(message, 'Close', config))
      )
      .subscribe();
    
  }

}
